/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GrantType } from '../model/grantType';
import { InlineResponse500 } from '../model/inlineResponse500';
import { LoginResponse } from '../model/loginResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AuthControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Restituisce un nuovo set di token d&#x27;accesso per l&#x27;utente se la combinazione di username e password fornita è valida.
     * 
     * @param id_slug_comune 
     * @param username Username dell&#x27;utente. Non può essere nullo o vuoto.
     * @param password Password dell&#x27;utente. Non può essere nullo o vuoto.
     * @param grant_type Grant type ammesso (case-insensitive): *password*
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public login(id_slug_comune: string, username: string, password: string, grant_type: GrantType, observe?: 'body', reportProgress?: boolean): Observable<LoginResponse>;
    public login(id_slug_comune: string, username: string, password: string, grant_type: GrantType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginResponse>>;
    public login(id_slug_comune: string, username: string, password: string, grant_type: GrantType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginResponse>>;
    public login(id_slug_comune: string, username: string, password: string, grant_type: GrantType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling login.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling login.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling login.');
        }

        if (grant_type === null || grant_type === undefined) {
            throw new Error('Required parameter grant_type was null or undefined when calling login.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (grant_type !== undefined && grant_type !== null) {
            queryParameters = queryParameters.set('grant_type', <any>grant_type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LoginResponse>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/auth/login`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce un nuovo set di token d&#x27;accesso a partire da un refresh token valido dell&#x27;utente.
     * 
     * @param id_slug_comune 
     * @param refresh_token Refresh token valido. Non può essere nullo o vuoto.
     * @param username Username dell&#x27;utente assegnatario del refresh token. Non può essere nullo o vuoto.
     * @param grant_type Grant type ammesso (case-insensitive): *refresh_token*
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshToken(id_slug_comune: string, refresh_token: string, username: string, grant_type: GrantType, observe?: 'body', reportProgress?: boolean): Observable<LoginResponse>;
    public refreshToken(id_slug_comune: string, refresh_token: string, username: string, grant_type: GrantType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginResponse>>;
    public refreshToken(id_slug_comune: string, refresh_token: string, username: string, grant_type: GrantType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginResponse>>;
    public refreshToken(id_slug_comune: string, refresh_token: string, username: string, grant_type: GrantType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling refreshToken.');
        }

        if (refresh_token === null || refresh_token === undefined) {
            throw new Error('Required parameter refresh_token was null or undefined when calling refreshToken.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling refreshToken.');
        }

        if (grant_type === null || grant_type === undefined) {
            throw new Error('Required parameter grant_type was null or undefined when calling refreshToken.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (refresh_token !== undefined && refresh_token !== null) {
            queryParameters = queryParameters.set('refresh_token', <any>refresh_token);
        }
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (grant_type !== undefined && grant_type !== null) {
            queryParameters = queryParameters.set('grant_type', <any>grant_type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LoginResponse>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/auth/token`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce un nuovo set di token d&#x27;accesso a partire da un refresh token valido dell&#x27;utente.
     * 
     * @param id_slug_comune 
     * @param refresh_token 
     * @param username 
     * @param grant_type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshTokenFormForm(id_slug_comune: string, refresh_token?: string, username?: string, grant_type?: GrantType, observe?: 'body', reportProgress?: boolean): Observable<LoginResponse>;
    public refreshTokenFormForm(id_slug_comune: string, refresh_token?: string, username?: string, grant_type?: GrantType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginResponse>>;
    public refreshTokenFormForm(id_slug_comune: string, refresh_token?: string, username?: string, grant_type?: GrantType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginResponse>>;
    public refreshTokenFormForm(id_slug_comune: string, refresh_token?: string, username?: string, grant_type?: GrantType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling refreshTokenForm.');
        }




        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (refresh_token !== undefined) {
            formParams = formParams.append('refresh_token', <any>refresh_token) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (grant_type !== undefined) {
            formParams = formParams.append('grant_type', <any>grant_type) as any || formParams;
        }

        return this.httpClient.request<LoginResponse>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/auth/tokenform`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di resettare la password di un utente a partire dal suo indirizzo email
     * 
     * @param id_slug_comune 
     * @param email The email address
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetUserPassword(id_slug_comune: string, email: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public resetUserPassword(id_slug_comune: string, email: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public resetUserPassword(id_slug_comune: string, email: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public resetUserPassword(id_slug_comune: string, email: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling resetUserPassword.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling resetUserPassword.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/auth/reset_password`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiornare la password di un utente a partire dal jti
     * 
     * @param id_slug_comune 
     * @param password The new password
     * @param token The token provided by email
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserPassword(id_slug_comune: string, password: string, token: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public updateUserPassword(id_slug_comune: string, password: string, token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public updateUserPassword(id_slug_comune: string, password: string, token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public updateUserPassword(id_slug_comune: string, password: string, token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateUserPassword.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling updateUserPassword.');
        }

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling updateUserPassword.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/auth/update_password`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
